// Left-rail brand panel — identical markup to the desktop's BrandRail.
// Contains logo, workspace tagline, and a short onboarding checklist. Lives
// in the auth-flow layout and (later) in the signed-in shell.
import type { ReactNode } from "react";
import { SignalLensLogo } from "./Icons";

interface BrandRailProps {
	bottomContent?: ReactNode;
}

export const BrandRail = ({ bottomContent }: BrandRailProps) => (
	<aside className="tg-sidebar relative grid min-h-0 grid-rows-[auto_auto_1fr_auto] gap-5 overflow-hidden px-5 py-5">
		<div className="tg-brand-glow pointer-events-none absolute inset-x-0 top-0 h-28" />

		<div className="tg-brand-mark relative z-10 inline-flex h-14 w-14 items-center justify-center rounded-full p-1.5">
			<SignalLensLogo className="h-full w-full" />
		</div>

		<div className="relative z-10">
			<span className="tg-text-muted mb-2 inline-flex text-[0.7rem] font-semibold uppercase tracking-[0.14em]">
				Telegram intelligence workspace
			</span>
			<h1 className="tg-text-primary max-w-[10ch] text-[clamp(2rem,2.8vw,2.9rem)] leading-[1.03] font-bold">
				SignalLens
			</h1>
			<p className="tg-text-secondary mt-3 max-w-[28ch] text-[0.93rem] leading-7">
				Multi-user Telegram sign-in and channel configuration, served from
				your self-hosted orchestrator.
			</p>
		</div>

		<div className="tg-surface tg-text-secondary relative z-10 rounded-2xl p-4">
			<h2 className="tg-text-primary mb-3 text-[0.95rem] font-semibold">
				First run flow
			</h2>
			<ul className="space-y-2.5 text-[0.9rem] leading-6">
				<li>1. Create your SignalLens account</li>
				<li>2. Add a profile and sign in with Telegram</li>
				<li>3. Assign text and image trading chats</li>
			</ul>
		</div>

		{bottomContent ? (
			<div className="relative z-10 min-h-0">{bottomContent}</div>
		) : null}
	</aside>
);
